const labelStrokeOffsets = [
  [-1, 0], [0, -1], [1, 0], [0, 1],
  [-1, -1], [1, -1], [-1, 1], [1, 1],
  [-2, 0], [0, -2], [2, 0], [0, 2],
  [-2, -2], [-1, -2], [1, -2], [2, -2],
  [-2, -1], [2, -1], [-3, 0], [3, 0],
  [-2, 1], [2, 1], [-2, 2], [-1, 2],
  [1, 2], [2, 2], [0, -3], [0, 3],
] as const

const formatStrokeOffset = (offset: number) => offset === 0 ? '0' : `${offset}px`

export const getLabelStroke = (strokeColor: string) => labelStrokeOffsets.map(
  ([xOffset, yOffset]) => (
    `${formatStrokeOffset(xOffset)} ${formatStrokeOffset(yOffset)} ${strokeColor}`
  )
).join(', ')
